import React from 'react';
import PlayIcon from 'assets/magazine/icons/icons-small-play.svg';
import {NavLink} from 'react-router-dom';
import {addPopup} from 'redux/actions';
import {useDispatch, useSelector} from 'react-redux';

import * as POPUP_TYPES from 'constants/popup-types';
import * as Routes from 'constants/routes';

import './index.scss';
import AnalyticsManager from '../../../../app/analytics';
import {combineClassNames, getDateFromUnix, getMediaPath} from 'app/functions';

const VideoArticleTile = ({article, skeleton, className, analyticsSource}) => {
    const dispatch = useDispatch();
    const magazineCategories = useSelector(store => store.data.magazineCategories);

    const handleClick = () => {
        AnalyticsManager.logVideoArticlePress(article?.id, article?.title, analyticsSource);

        dispatch(addPopup({
            type: POPUP_TYPES.VIDEO_ARTICLE,
            article: article,
            shouldRedirect: true,
            popup_id: Math.round(Math.random() * 1000000),
        }))
    }

    const getVideoImage = () => {
        if (article.thumbnail_img_id) {
            return getMediaPath(article.thumbnail_img_id);
        }

        return article.thumbnail_url;
    }

    if (!skeleton) {
        const filteredCategory = (magazineCategories?.filter((item) => item.id === article.related_category))[0];
        const category = filteredCategory ? filteredCategory : {title: ""};
        const toLink = `${Routes.magazine}/${category.title}/${article.id}`;
        return (
            <TileWrapper
                type={article.type}
                className={combineClassNames('video-article-preview-wrapper', className)}
                popup={handleClick}
                to={toLink}
            >
                <div className="article-img-wrapper">
                    <img src={getVideoImage()} alt={article.thumbnail_alt || article.title || article.header_name}
                         className='article-img'/>
                    <img src={PlayIcon} alt="הפעל סרטון" className='play-btn'/>
                </div>
                <div className="article-preview-footer">
                    <div className="article-headline">
                        {article.title || article.header_name}
                    </div>

                    {(article.sub_title || article.header_sub_name) && (
                        <div className="article-details">
                            {article.sub_title || article.header_sub_name}
                        </div>
                    )}

                    <div className="article-details">
                        {article.author && article.author + ' | '}
                        {getDateFromUnix(article.article_date)}
                    </div>
                </div>

            </TileWrapper>);
    } else {
        return (
            <div className='video-article-preview-wrapper skeleton'>
                <div className="article-img-wrapper skeleton">
                    <div className="shimmer-wrapper">
                        <div className="shimmer"></div>
                    </div>
                </div>
                <div className="article-preview-footer">
                    <div className="article-headline skeleton">
                        <div className="shimmer-wrapper">
                            <div className="shimmer"></div>
                        </div>
                    </div>
                    <div className="article-details skeleton">
                        <div className="shimmer-wrapper">
                            <div className="shimmer"></div>
                        </div>
                    </div>
                    <div className="article-details skeleton">
                        <div className="shimmer-wrapper">
                            <div className="shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoArticleTile;

const TileWrapper = (props) => {
    const {children, type, to, popup, className} = props;
    if (type === 'video text') {
        return (
            <NavLink to={to} className={className}>
                {children}
            </NavLink>
        )
    } else {
        return (
            <div className={className} onClick={popup}>
                {children}
            </div>
        )
    }
}
